/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    export class MeevoTimeDisplay implements angular.IDirective {
        restrict = "E";
        scope = {
            clock: "=?",
            template: "@?"

        };
        template = `<div ng-if="!!template">
                        <div ng-include="template"></div>
                    </div>
                    <div ng-if="!template">
                        <div layout="row" layout-align="start center">
                             <div class="time">
                                 <div>{{ clock.time | date: format.time}}</div>
                             </div>
                             <div class="am-pm" ng-show="format.showAmPm">
                                 <div>{{ clock.time | date: 'a'}}</div>
                             </div>
                         </div>
                         <div class="full-date" ng-class="{'layout-row': deviceParams.isLargeTablet && deviceParams.isPortrait, 'layout-column': !deviceParams.isLargeTablet}">
                             <div class="day-of-week">
                                 <div>{{ clock.time | date: 'EEE'}}</div>
                             </div>
                             <div layout="row" class="month">
                                 <div>
                                     <div>{{ clock.time | date: 'longDateWithoutYear'}}</div>
                                 </div>
                             </div>
                         </div>
                    </div>`
        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {

            let that = scope;
            let timers = [];

            if (this.appSettings.APP_TIME_FORMAT == Meevo.Model.TimeFormatEnum.TimeFormat12) {
                scope.format = { time: this.$locale.DATETIME_FORMATS.shortTime.replaceAll('a', ''), showAmPm: true };
            } else {
                scope.format = { time: this.$locale.DATETIME_FORMATS.shortTime, showAmPm: false };
            }
            
            scope.clock = { time: Date.now(), interval: 5000 };
            this.dataService.customMethodData('/api/TimeClock/LocationTime', 'GET', null).then((result: any) => {
                scope.clock.time = moment(result.data.locationTime).format(),
                    getLocationTime(scope.clock.interval);
            })

            var getLocationTime = ((seconds): void => {
                timers.push(window.setInterval(() => {
                    scope.$apply(() => { scope.clock.time = moment(scope.clock.time).add(5, 'seconds').format() });
                }, seconds));

                timers.push(window.setInterval(() => {
                    var that = this;
                    if (that.identityService.current().isAuthenticated) {
                        that.dataService.customMethodData('/api/TimeClock/LocationTime', 'GET', null).then((result: any) => {
                            scope.clock.time = moment(result.data.locationTime).format()
                        });
                    }
                }, 300000));
            })

            scope.$on("$destroy", () => {
                _.each(timers, (timer) => { clearInterval(timer); });
            });

        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService, private identityService: Meevo.Components.Common.IIdentityService, private appSettings: Meevo.Components.Common.IAppSettings, protected $locale: angular.ILocaleService) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService, identityService: Meevo.Components.Common.IIdentityService, appSettings: Meevo.Components.Common.IAppSettings, $locale: angular.ILocaleService) => {
                return new MeevoTimeDisplay(dataService, identityService, appSettings, $locale);
            };
            directive.$inject = [
                "meevo.components.common.DataService",
                "meevo.components.common.IdentityService",
                "meevo.AppSettings",
                "$locale"
            ];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoTimeDisplay", MeevoTimeDisplay.factory());
}